import { createFileRoute, redirect } from '@tanstack/react-router';

// Direction-2 redirect — the brief wizard collapsed in §12.2L. Voice
// is no longer a standalone step; it's an expandable card on the
// /brand/$slug/brief review surface. This route stays as a redirect
// so any in-flight bookmarks or stale links land in the right place.
// Direct voice editing outside onboarding still lives at
// /brand/$slug/voice.

interface VoiceSearch {
  onboarding?: '1' | undefined;
}

export const Route = createFileRoute('/brand/$slug/brief/voice')({
  validateSearch: (search: Record<string, unknown>): VoiceSearch =>
    search['onboarding'] === '1' ? { onboarding: '1' } : {},
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/brand/$slug/brief',
      params: { slug: params.slug },
      search: search.onboarding === '1' ? { onboarding: '1' as const } : {},
    });
  },
  component: () => null,
});
